export const SHOW_SIDE_BAR_SET = 'SHOW_SIDE_BAR_SET';
export const HIDE_SIDE_BAR_SET = 'HIDE_SIDE_BAR_SET';

export const CONNECT_DIALOG_SHOW = 'CONNECT_DIALOG_SHOW';
export const CONNECT_DIALOG_HIDE = 'CONNECT_DIALOG_HIDE';
